import { Component, Injectable, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PdqUser } from '@pdqdev/pdq-shared/dist/entities';
import { ILinkUp } from '@pdqdev/pdq-shared/dist/interfaces';

@Injectable()
@Component({
  selector: 'link-up-main',
  templateUrl: './link-up-main.component.html',
  styleUrls: ['./link-up-main.component.scss'],
  standalone: false,
})
export class LinkUpMainComponent implements OnInit, OnChanges {
  @Input() linkUp: ILinkUp.Details;
  @Input() currentPdqUser: PdqUser;
  desktopClientConnected: boolean = true;
  adjustedUsername: string = '';

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.linkUp) {
      this.adjustUsername(this.currentPdqUser.email);
    }
  }

  adjustUsername(userEmail: string) {
    const baseUserName = this.linkUp?.printNodeUsername;
    if (baseUserName) {
      const atIndex = userEmail.indexOf('@');
      this.adjustedUsername = userEmail.slice(0, atIndex) + '#' + baseUserName + userEmail.slice(atIndex);
    }
  }

  copyToClipboard(val: string) {
    navigator.clipboard.writeText(val);
  }
}
